/* eslint-disable camelcase */
import * as marietta from '../..';

class RoomWallCollection {
    floor:number;

    index:number;

    roomIndex:number;

    id:string;

    start:{x: number, y: number, wall_type: number};

    end:{x: number, y: number, wall_type: number};

    /**
     * コンストラクタ
     */
    constructor(startPoint: {x: number, y: number, wall_type: number} = { x: null, y: null, wall_type: 1 }, endPoint: {x: number, y: number, wall_type: number} = { x: null, y: null, wall_type: 1 }) {
      this.start = startPoint;
      this.end = endPoint;
    }

    /**
     * クローン
     * @return marietta.webcad.collection.PointCollection
     */
    clone(): marietta.webcad.collection.RoomWallCollection {
      const ret: marietta.webcad.collection.RoomWallCollection = new marietta.webcad.collection.RoomWallCollection(this.start, this.end);
      ret.start = this.start;
      ret.end = this.end;
      ret.floor = this.floor;
      ret.index = this.index;
      ret.roomIndex = this.roomIndex;
      ret.id = this.id;
      return ret;
    }

    get startPoint(): marietta.core.Point { return new marietta.core.Point(this.start.x, this.start.y); }

    get endPoint(): marietta.core.Point { return new marietta.core.Point(this.end.x, this.end.y); }
}
export default RoomWallCollection;
